import { render, staticRenderFns } from "./gtr-module-menu-item.vue?vue&type=template&id=6013213d&scoped=true"
import script from "./gtr-module-menu-item.ts?vue&type=script&lang=ts&external"
export * from "./gtr-module-menu-item.ts?vue&type=script&lang=ts&external"
import style0 from "./gtr-module-menu-item.vue?vue&type=style&index=0&id=6013213d&prod&scoped=true&lang=css"
import style1 from "./gtr-module-menu-item.vue?vue&type=style&index=1&id=6013213d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013213d",
  null
  
)

export default component.exports